import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@upr-web-primer/geolocation';
import { GEO_NON_PRIMARY_RESIDENT_VALUE } from '@upr-web-primer/geolocation';
import { isEmpty, filter, find, get, isArray, map, intersection, includes } from 'lodash-es';

class GdsPoiFilterModule {
}
GdsPoiFilterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
GdsPoiFilterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterModule });
GdsPoiFilterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class GdsPoiFilterService {
    constructor(geo) {
        this.geo = geo;
    }
    filterResults(tiles, selection, promo) {
        if (isEmpty(tiles)) {
            return [];
        }
        if (!selection) {
            return tiles;
        }
        let geo;
        if (promo) {
            const geoLocation = this.geo.getGeoLocationObject();
            geo =
                geoLocation?.region !== GEO_NON_PRIMARY_RESIDENT_VALUE ? 'fl' : 'ous';
        }
        return filter(tiles, (tile) => {
            const noMatch = find(selection, (value, property) => !this.matchesProperties(tile, property, value));
            if (noMatch) {
                return false;
            }
            if (selection.express_pass &&
                get(tile, 'Meta.ExpressPass[0].Key', '').toLowerCase() !== 'yes') {
                return false;
            }
            if (selection.healthy_options &&
                get(tile, 'Meta.HealthyOptions[0].Key', '').toLowerCase() !== 'yes') {
                return false;
            }
            if (promo) {
                const persona = get(tile, 'Meta.Persona.0.Key');
                if (!persona || persona === 'All') {
                    return true;
                }
                if (!geo) {
                    return persona === 'ous';
                }
                return geo === persona;
            }
            return true;
        });
    }
    getTileKeys(tile, key) {
        const property = get(tile, `Meta.${key}`, null);
        if (isEmpty(property)) {
            return null;
        }
        return isArray(property) ? map(property, 'Key') : get(property, 'Key');
    }
    matchesProperties(tile, property, criteria = null) {
        const isCriteriaEmpty = isEmpty(criteria);
        const isCriteriaArray = isArray(criteria);
        const tileKey = property === 'accessibility'
            ? this.getAccessibilityKeys(tile)
            : this.getTileKeys(tile, property);
        if (property === 'AttractionLocations' && isCriteriaEmpty) {
            return false;
        }
        if (isEmpty(tileKey) && isCriteriaEmpty) {
            return true;
        }
        if (isCriteriaEmpty) {
            return true;
        }
        if (isCriteriaArray
            ? find(criteria, (item) => this.checkCriteriaAll(item))
            : this.checkCriteriaAll(criteria)) {
            return true;
        }
        return isCriteriaArray
            ? intersection(criteria, tileKey).length > 0
            : includes(tileKey, criteria);
    }
    getAccessibilityKeys(tile) {
        const property = get(tile, `Content.Accessibility`, null);
        if (isEmpty(property)) {
            return null;
        }
        return isArray(property) ? map(property, 'Key') : get(property, 'Key');
    }
    checkCriteriaAll(criteria) {
        return !!criteria && (criteria === 'all' || criteria.startsWith('all_'));
    }
}
GdsPoiFilterService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterService, deps: [{ token: i1.GeolocationService }], target: i0.ɵɵFactoryTarget.Injectable });
GdsPoiFilterService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: GdsPoiFilterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.GeolocationService }]; } });

export { GdsPoiFilterModule, GdsPoiFilterService };
